<app-modal [id]="modalId" [maskClose]="false">
  <aside class="modal confirm-modal">
    <div class="modal-body">
      <div class="header" [ngClass]="{modalCode: titleCode}">
        <p class="title">{{titleCode}}</p>
        <div class="button regular close" (click)="cancel()"><span class="icon">&#x00D7;</span></div>
      </div>
      <div class="content" >
        <div class="code" *ngIf="code">
          <span>{{code}}</span>
        </div>
        <p class="title" *ngIf="text">{{text}}</p>
        <p class="subtitle" *ngIf="subText">{{subText}}</p>
      </div>
      <div class="footer">
        <button class="button regular solid-green"  *ngIf="!hideButtonText" (click)="upgrade()">{{buttonText}}</button>
        <p (click)="learnMore()" *ngIf="learnMoreButton">Learn More</p>
      </div>
    </div>
  </aside>
  <div class="confirm-modal-background"></div>
</app-modal>
